/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_Type_Price_DropInputs */

const he_notifications_type_price_drop = /** @type {(inputs: Notifications_Type_Price_DropInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ירידת מחיר`)
};

const en_notifications_type_price_drop = /** @type {(inputs: Notifications_Type_Price_DropInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Price Drop`)
};

/**
* | output |
* | --- |
* | "Price Drop" |
*
* @param {Notifications_Type_Price_DropInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const notifications_type_price_drop = /** @type {((inputs?: Notifications_Type_Price_DropInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Type_Price_DropInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_notifications_type_price_drop(inputs)
	return en_notifications_type_price_drop(inputs)
});